<template>
  <v-container fluid>
    <div>
      <!-- Automatically updated by .gitlab-ci.yml -->
      Branch: bugfix/1.6.1<br />
      Commit: 3dff98c2<br />
      Build Date: 2026-05-15T07:07:32Z
    </div>
  </v-container>
</template>

<script>
/* eslint-disable indent */
  export default {
    name: 'Version'
  };
</script>
<style scoped>
  img {
    height: 15vh;
  }
</style>



// WEBPACK FOOTER //
// version.vue